export default __webpack_public_path__ + "static/media/Path 129.75c79ebb.svg";